import { render, staticRenderFns } from "./carriage.vue?vue&type=template&id=a7af1128&scoped=true&"
import script from "./carriage.vue?vue&type=script&lang=js&"
export * from "./carriage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7af1128",
  null
  
)

export default component.exports